module.exports = __webpack_public_path__ + "static/1-a6069743b25c3c5e05d09771808e2be4.jpeg";